import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const DeadlineCountdown = ({ deadline, title, description, priority }) => {
  const [timeRemaining, setTimeRemaining] = useState({ days: 0, hours: 0, minutes: 0 });

  useEffect(() => {
    const calculateTimeRemaining = () => {
      const now = new Date('2026-01-13T22:43:33');
      const deadlineDate = new Date(deadline);
      const diff = deadlineDate - now;

      if (diff > 0) {
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        setTimeRemaining({ days, hours, minutes });
      } else {
        setTimeRemaining({ days: 0, hours: 0, minutes: 0 });
      }
    };

    calculateTimeRemaining();
    const interval = setInterval(calculateTimeRemaining, 60000);

    return () => clearInterval(interval);
  }, [deadline]);

  const getPriorityStyles = () => {
    switch (priority) {
      case 'critical':
        return 'border-error bg-error/5';
      case 'high':
        return 'border-warning bg-warning/5';
      default:
        return 'border-border bg-muted/5';
    }
  };

  const getPriorityIcon = () => {
    switch (priority) {
      case 'critical':
        return 'AlertTriangle';
      case 'high':
        return 'AlertCircle';
      default:
        return 'Clock';
    }
  };

  const getPriorityColor = () => {
    switch (priority) {
      case 'critical':
        return 'var(--color-error)';
      case 'high':
        return 'var(--color-warning)';
      default:
        return 'var(--color-muted-foreground)';
    }
  };

  return (
    <div className={`border rounded-lg p-4 transition-smooth ${getPriorityStyles()}`}>
      <div className="flex items-start gap-3 mb-3">
        <Icon name={getPriorityIcon()} size={20} color={getPriorityColor()} />
        <div className="flex-1">
          <h4 className="font-heading font-semibold text-sm md:text-base text-foreground mb-1">
            {title}
          </h4>
          <p className="text-xs text-muted-foreground">{description}</p>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <div className="bg-card rounded-md p-2 text-center">
          <p className="text-xl md:text-2xl font-bold data-text text-foreground">{timeRemaining?.days}</p>
          <p className="text-xs caption text-muted-foreground">Days</p>
        </div>
        <div className="bg-card rounded-md p-2 text-center">
          <p className="text-xl md:text-2xl font-bold data-text text-foreground">{timeRemaining?.hours}</p>
          <p className="text-xs caption text-muted-foreground">Hours</p>
        </div>
        <div className="bg-card rounded-md p-2 text-center">
          <p className="text-xl md:text-2xl font-bold data-text text-foreground">{timeRemaining?.minutes}</p>
          <p className="text-xs caption text-muted-foreground">Mins</p>
        </div>
      </div>
    </div>
  );
};

export default DeadlineCountdown;